<div class="sidebar-panel">
  <div
    id="scroll-area"
    [perfectScrollbar]
    class="navigation-hold"
    fxLayout="column"
  >
    <div class="sidebar-hold">
      <!-- App Logo -->
      <div class="branding" style="cursor: pointer" routerLink="/home">
        <img
          src="assets/images/egret.png"
          alt=""
          class="app-logo"
          *ngIf="!currentUser.companyLogo"
        />
        <img
          src="{{ currentUser.companyLogo }}"
          alt=""
          class="app-logo"
          *ngIf="currentUser.companyLogo"
        />
        <span class="app-logo-text">{{
          currentUser.companyCode
            ? upperCaseCompany(currentUser.companyCode)
            : "OMS"
        }}</span>

        <span
          style="margin: auto"
          *ngIf="layoutConf.sidebarStyle !== 'compact'"
        ></span>
      </div>

      <!-- Navigation -->
      <app-sidenav
        [items]="menuItems"
        [hasIconMenu]="hasIconTypeMenuItem"
        [iconMenuTitle]="iconTypeMenuTitle"
      ></app-sidenav>
    </div>
  </div>
</div>
